import {
    AfterViewInit,
    Component,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { StepIds } from '../../../models/property-step/property-step-model';
import { PropertyFeaturesSectionComponent } from '../../../sections/property-default-sections/property-features-section/property-features-section.component';
import { PropertyInformationSectionComponent } from '../../../sections/property-default-sections/property-information-section/property-information-section.component';
import { PropertyRentalAvailabilitySectionComponent } from '../../../sections/residential-for-rent/property-rental-availability-section/property-rental-availability-section.component';
import { PropertyRentalDetailsSectionComponent } from '../../../sections/residential-for-rent/property-rental-details-section/property-rental-details-section.component';
import { PropertyRentalRentiSectionComponent } from '../../../sections/residential-for-rent/property-rental-renti-section/property-rental-renti-section.component';
import { PropertyParkingSectionComponent } from '../../../sections/property-default-sections/property-parking-section/property-parking-section.component';
import { DraftFacade, RouterFacade } from '@classifieds-sell/state';
import { PropertyPageBase } from '../../property-page-base';

@Component({
    templateUrl: './property-information-page.component.html',
    styleUrls: ['./property-information-page.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ResidentialForRentPropertyInformationComponent
    extends PropertyPageBase
    implements AfterViewInit, OnInit, OnDestroy {
    @ViewChild(PropertyInformationSectionComponent, {
        read: PropertyInformationSectionComponent
    })
    propertyInformationSection: PropertyInformationSectionComponent;

    @ViewChild(PropertyFeaturesSectionComponent, {
        read: PropertyFeaturesSectionComponent
    })
    propertyFeaturesSectionComponent: PropertyFeaturesSectionComponent;

    @ViewChild(PropertyRentalAvailabilitySectionComponent, {
        read: PropertyRentalAvailabilitySectionComponent
    })
    propertyRentalAvailabilitySection: PropertyRentalAvailabilitySectionComponent;

    @ViewChild(PropertyRentalDetailsSectionComponent, {
        read: PropertyRentalDetailsSectionComponent
    })
    propertyRentalDetailsSectionComponent: PropertyRentalDetailsSectionComponent;

    @ViewChild(PropertyRentalRentiSectionComponent, {
        read: PropertyRentalRentiSectionComponent
    })
    propertyRentalRentiSectionComponent: PropertyRentalRentiSectionComponent;
    @ViewChild(PropertyParkingSectionComponent, {
        read: PropertyParkingSectionComponent
    })
    propertyParkingSectionComponent: PropertyParkingSectionComponent;

    constructor(draftFacade: DraftFacade, routerFacade: RouterFacade) {
        super(StepIds.propertyInformation, draftFacade, routerFacade);
    }

    ngOnInit(): void {
        super.onInit();
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }

    ngAfterViewInit() {
        super.registerSection(this.propertyInformationSection);
        super.registerSection(this.propertyRentalAvailabilitySection);
        super.registerSection(this.propertyRentalDetailsSectionComponent);
        super.registerSection(this.propertyRentalRentiSectionComponent);
        super.registerSection(this.propertyFeaturesSectionComponent);
        super.registerSection(this.propertyParkingSectionComponent);
    }
}
